import { v4 as uuidv4 } from "uuid";

// eslint-disable-next-line no-underscore-dangle
const newIdAttributesGenerator = (x) => (x?.__isNew__ ? uuidv4() : x?.value);

export default newIdAttributesGenerator;
